import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './PREAUCT_Auction_Opportunity.css';

const PREAUCT_Auction_Opportunity = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"PREAUCT_AUCTION_OPPORTUNITY",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	PREAUCT_AUCTION_OPPORTUNITY:-1
  });


  const [PREAUCT_AUCTION_OPPORTUNITY, setPREAUCT_AUCTION_OPPORTUNITY] = React.useState(null);
  const [PREAUCT_AUCTION_OPPORTUNITY_D, setPREAUCT_AUCTION_OPPORTUNITY_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Pre-Auction Auction Opportunity');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/PREAUCT_Auction_Opportunity',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPREAUCT_AUCTION_OPPORTUNITY(clientInfo,"OpenNew");

		navigate('/PREAUCT_Auction_Opportunity',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Auction_Opportunity_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPREAUCT_AUCTION_OPPORTUNITY(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPREAUCT_AUCTION_OPPORTUNITY(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPREAUCT_AUCTION_OPPORTUNITY(clientInfo,"OpenNew");
		}
		navigate('/PREAUCT_Auction_Opportunity',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Auction_Opportunity_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Auction_Opportunity_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Auction_Opportunity_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
		if(Temp_Data2.status!="New"){
			handleDeletePREAUCT_AUCTION_OPPORTUNITY(Temp_Data2);
			navigate('/PREAUCT_Auction_Opportunity#New',{replace:true});
		} 
		else 
			navigate('/PREAUCT_Auction_Opportunity',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Auction_Opportunity',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Auction_Opportunity',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Auction_Opportunity',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Auction_Opportunity',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!PREAUCT_AUCTION_OPPORTUNITY) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_${i}_SECTION`;
	  const headerId = `#PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [PREAUCT_AUCTION_OPPORTUNITY]) ;


  
  
  var Ids = [];
  for(var Ele in PREAUCT_AUCTION_OPPORTUNITY){
	  for(var Sec in PREAUCT_AUCTION_OPPORTUNITY[Ele]){
		if(Sec == "id")
			Ids.push(PREAUCT_AUCTION_OPPORTUNITY[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(PREAUCT_AUCTION_OPPORTUNITY[Ele]["status"]);
		else if(Array.isArray(PREAUCT_AUCTION_OPPORTUNITY[Ele][Sec]))
			  for(var Row in PREAUCT_AUCTION_OPPORTUNITY[Ele][Sec])  // Convert to PREAUCT_AUCTION_OPPORTUNITY[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in PREAUCT_AUCTION_OPPORTUNITY[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["PREAUCT_AUCTION_OPPORTUNITY"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPREAUCT_AUCTION_OPPORTUNITY(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_AUCTION_OPPORTUNITY`).then((response1) => {
		if(!PREAUCT_AUCTION_OPPORTUNITY) 
			setPREAUCT_AUCTION_OPPORTUNITY(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_AUCTION_OPPORTUNITY_D`).then((response2) => {
			setPREAUCT_AUCTION_OPPORTUNITY_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPREAUCT_AUCTION_OPPORTUNITY_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPREAUCT_AUCTION_OPPORTUNITY = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_AUCTION_OPPORTUNITY/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPREAUCT_AUCTION_OPPORTUNITY(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPREAUCT_AUCTION_OPPORTUNITY = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_AUCTION_OPPORTUNITY/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPREAUCT_AUCTION_OPPORTUNITY = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_AUCTION_OPPORTUNITY/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPREAUCT_AUCTION_OPPORTUNITY = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_AUCTION_OPPORTUNITY', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePREAUCT_AUCTION_OPPORTUNITY = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_AUCTION_OPPORTUNITY', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["1"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_0"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_0",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["1"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_1"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_1",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["1"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_2"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_2",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["1"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_3"]=value;
	Form_Data_onChange("1","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_3",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  


const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["1"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_4"]=value;
	Form_Data_onChange("1","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_4",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  

    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["2"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_0"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_0",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["2"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_1"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_1",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["2"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_2"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_2",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["2"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_3"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_3",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["2"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_4"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_4",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  

    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["2"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_5"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_5",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["3"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_0"]=value;
	Form_Data_onChange("3","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_0",value,Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
  }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["3"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_1"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_1",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["3"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_2"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_2",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["3"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_3"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_3",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["3"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_4"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_4",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["4"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_0"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("4","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_0",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
  
      
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_0"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_0",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  



const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_1"]=value;
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_1",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  


const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_2"]=value;
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_2",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  

    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_3"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_3",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_4"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_4",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_5"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_5",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_6"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_6",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_7_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_7"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_7",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_8_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_8"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_8"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_8",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_9_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_9"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_9"]=value;
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_9",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  


const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_10_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_10"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_10"]=value;
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_10",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  


const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_11_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_11"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_11"]=value;
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_11",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  


const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_12_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_12"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_12"]=value;
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_12",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  

    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_13_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_13"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_13"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_13",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_14_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_14"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_14"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_14",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_15_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_15"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_15"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_15",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_16_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_16"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_16"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_16",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_17_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_17"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_17"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_17",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_18_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_18"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_18"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_18",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_19_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_19"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_19"]=value;
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_19",value,Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
  }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_20_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_20"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_20"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_20",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_21_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_21"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["8"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_21"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("8","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_21",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["9"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_0"]=value;
	Form_Data_onChange("9","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_0",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
  }; 
  

    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["9"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_1"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_1",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["9"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_2"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_2",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["9"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_3"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_3",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
	Temp_Data["9"]["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_4"]=value;
	//handleAddPREAUCT_AUCTION_OPPORTUNITY(Temp_Data,App_Data['PREAUCT_AUCTION_OPPORTUNITY']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_4",value,Temp_Data);
 	//handleLastDataPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
    setPREAUCT_AUCTION_OPPORTUNITY(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!PREAUCT_AUCTION_OPPORTUNITY) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPREAUCT_AUCTION_OPPORTUNITY =JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
  updatedPREAUCT_AUCTION_OPPORTUNITY[Sec] = [...updatedPREAUCT_AUCTION_OPPORTUNITY[Sec], newRow];
  setPREAUCT_AUCTION_OPPORTUNITY(updatedPREAUCT_AUCTION_OPPORTUNITY);
};

const handleDeleteRow = (sec,index) => {
  const updatedPREAUCT_AUCTION_OPPORTUNITY = JSON.parse(JSON.stringify(PREAUCT_AUCTION_OPPORTUNITY));
  updatedPREAUCT_AUCTION_OPPORTUNITY[sec].splice(index, 1);
  setPREAUCT_AUCTION_OPPORTUNITY(updatedPREAUCT_AUCTION_OPPORTUNITY);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Pre-Auction Auction Opportunity`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Pre-Auction Opportunity ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Auction Opportunity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_0" type="text" className="form-control" placeholder="PREAUCT Auction Opportunity ID" value={PREAUCT_AUCTION_OPPORTUNITY["1"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_0`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Auction Opportunity ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Auction Source`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_1" type="text" className="form-control" placeholder="Auction Source" value={PREAUCT_AUCTION_OPPORTUNITY["1"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_1`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Auction Source`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Auction Source Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_2" type="text" className="form-control" placeholder="Auction Source Link" value={PREAUCT_AUCTION_OPPORTUNITY["1"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_2`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Auction Source Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Auction Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_3"  value={PREAUCT_AUCTION_OPPORTUNITY["1"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_3`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_3_Change} className="form-control" name="Auction Type"  >
						  <option value="Foreclosure">Foreclosure</option>
						  <option value="Tax Sale">Tax Sale</option>
						  <option value="Sheriff Sale">Sheriff Sale</option>
						  <option value="Bankruptcy Sale">Bankruptcy Sale</option>
						  <option value="REO Auction">REO Auction</option>
						  <option value="Private Auction">Private Auction</option>
						  <option value="Online Auction">Online Auction</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Auction Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Auction Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_4"  value={PREAUCT_AUCTION_OPPORTUNITY["1"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_4`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_1_4_Change} className="form-control" name="Auction Status"  >
						  <option value="Identified">Identified</option>
						  <option value="Due Diligence">Due Diligence</option>
						  <option value="Pool Open">Pool Open</option>
						  <option value="Bid Authorized">Bid Authorized</option>
						  <option value="Bid Submitted">Bid Submitted</option>
						  <option value="Won">Won</option>
						  <option value="Lost">Lost</option>
						  <option value="Cancelled">Cancelled</option>
						  <option value="Closed">Closed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Auction Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Asset Name`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_0" type="text" className="form-control" placeholder="Asset Name" value={PREAUCT_AUCTION_OPPORTUNITY["2"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_0`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Asset Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '200ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Street Address`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_1" type="text" className="form-control" placeholder="Street Address" value={PREAUCT_AUCTION_OPPORTUNITY["2"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_1`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '200ch' }}>
						 {t(`Enter Street Address`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`City`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_2" type="text" className="form-control" placeholder="City" value={PREAUCT_AUCTION_OPPORTUNITY["2"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_2`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter City`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`County`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_3" type="text" className="form-control" placeholder="County" value={PREAUCT_AUCTION_OPPORTUNITY["2"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_3`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter County`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`State`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_4"  value={PREAUCT_AUCTION_OPPORTUNITY["2"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_4`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_4_Change} className="form-control" name="State"  >
						  <option value="AL">AL</option>
						  <option value="AK">AK</option>
						  <option value="AZ">AZ</option>
						  <option value="AR">AR</option>
						  <option value="CA">CA</option>
						  <option value="CO">CO</option>
						  <option value="CT">CT</option>
						  <option value="DE">DE</option>
						  <option value="FL">FL</option>
						  <option value="GA">GA</option>
						  <option value="HI">HI</option>
						  <option value="ID">ID</option>
						  <option value="IL">IL</option>
						  <option value="IN">IN</option>
						  <option value="IA">IA</option>
						  <option value="KS">KS</option>
						  <option value="KY">KY</option>
						  <option value="LA">LA</option>
						  <option value="ME">ME</option>
						  <option value="MD">MD</option>
						  <option value="MA">MA</option>
						  <option value="MI">MI</option>
						  <option value="MN">MN</option>
						  <option value="MS">MS</option>
						  <option value="MO">MO</option>
						  <option value="MT">MT</option>
						  <option value="NE">NE</option>
						  <option value="NV">NV</option>
						  <option value="NH">NH</option>
						  <option value="NJ">NJ</option>
						  <option value="NM">NM</option>
						  <option value="NY">NY</option>
						  <option value="NC">NC</option>
						  <option value="ND">ND</option>
						  <option value="OH">OH</option>
						  <option value="OK">OK</option>
						  <option value="OR">OR</option>
						  <option value="PA">PA</option>
						  <option value="RI">RI</option>
						  <option value="SC">SC</option>
						  <option value="SD">SD</option>
						  <option value="TN">TN</option>
						  <option value="TX">TX</option>
						  <option value="UT">UT</option>
						  <option value="VT">VT</option>
						  <option value="VA">VA</option>
						  <option value="WA">WA</option>
						  <option value="WV">WV</option>
						  <option value="WI">WI</option>
						  <option value="WY">WY</option>
						  <option value="DC">DC</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter State
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '15ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`ZIP Code`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_5" type="text" className="form-control" placeholder="ZIP Code" value={PREAUCT_AUCTION_OPPORTUNITY["2"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_5`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_2_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '15ch' }}>
						 {t(`Enter ZIP Code`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Auction Date`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Auction Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_0" type="date"  value={PREAUCT_AUCTION_OPPORTUNITY["3"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_0`]} 
							onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_0_Change} style={{ borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Auction Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Bid Deadline`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_1" type="text" className="form-control" placeholder="Bid Deadline" value={PREAUCT_AUCTION_OPPORTUNITY["3"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_1`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Bid Deadline`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Opening Bid USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_2" type="text" className="form-control" placeholder="Opening Bid USD" value={PREAUCT_AUCTION_OPPORTUNITY["3"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_2`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Opening Bid USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Estimated Value USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_3" type="text" className="form-control" placeholder="Estimated Value USD" value={PREAUCT_AUCTION_OPPORTUNITY["3"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_3`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Estimated Value USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Deposit Required USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_4" type="text" className="form-control" placeholder="Deposit Required USD" value={PREAUCT_AUCTION_OPPORTUNITY["3"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_4`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_3_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Deposit Required USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Opportunity Notes`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Opportunity Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_0" type="text" className="form-control" placeholder="Opportunity Notes" value={PREAUCT_AUCTION_OPPORTUNITY["4"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_0`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Opportunity Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Map Display Enabled`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Map Display Enabled`)} <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_0_Change} 
					  checked={PREAUCT_AUCTION_OPPORTUNITY?.["8"]?.["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_0"] === "true" || PREAUCT_AUCTION_OPPORTUNITY?.["8"]?.["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_0"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Public Visibility`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_1"  value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_1`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_1_Change} className="form-control" name="Map Public Visibility"  >
						  <option value="Exact Public Boundary">Exact Public Boundary</option>
						  <option value="Approximate Public Boundary">Approximate Public Boundary</option>
						  <option value="Hidden From Public">Hidden From Public</option>
						  <option value="Investor Only After Login">Investor Only After Login</option>
						  <option value="Accredited / Approved Investor Only">Accredited / Approved Investor Only</option>
						  <option value="Internal Only">Internal Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Public Visibility
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Listing Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_2"  value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_2`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_2_Change} className="form-control" name="Map Listing Status"  >
						  <option value="Not Listed">Not Listed</option>
						  <option value="Pre-Listing Draft">Pre-Listing Draft</option>
						  <option value="Preview Only">Preview Only</option>
						  <option value="Listed - Not Investable">Listed - Not Investable</option>
						  <option value="Listed - Investment Open">Listed - Investment Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Listing Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Map Place ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_3" type="text" className="form-control" placeholder="Google Map Place ID" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_3`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Google Map Place ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Maps URL`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_4" type="text" className="form-control" placeholder="Google Maps URL" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_4`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Google Maps URL`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '240ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Display Address`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_5" type="text" className="form-control" placeholder="Map Display Address" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_5`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '240ch' }}>
						 {t(`Enter Map Display Address`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Latitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_6" type="text" className="form-control" placeholder="Map Center Latitude" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_6`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_6_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_6"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Latitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Longitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_7" type="text" className="form-control" placeholder="Map Center Longitude" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_7`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_7_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_7"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Longitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Default Zoom`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_8" type="text" className="form-control" placeholder="Map Default Zoom" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_8`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_8_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_8"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Map Default Zoom`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_9"  value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_9`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_9_Change} className="form-control" name="Boundary Type"  >
						  <option value="Point Only">Point Only</option>
						  <option value="Parcel Boundary">Parcel Boundary</option>
						  <option value="Building Footprint">Building Footprint</option>
						  <option value="Unit Boundary">Unit Boundary</option>
						  <option value="Multi-Parcel Boundary">Multi-Parcel Boundary</option>
						  <option value="Multi-Building Boundary">Multi-Building Boundary</option>
						  <option value="Development Site Boundary">Development Site Boundary</option>
						  <option value="Easement / Access Boundary">Easement / Access Boundary</option>
						  <option value="Estimated Boundary">Estimated Boundary</option>
						  <option value="Confidential Boundary">Confidential Boundary</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_10"  value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_10`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_10_Change} className="form-control" name="Boundary Source"  >
						  <option value="Google Maps">Google Maps</option>
						  <option value="Manual Pin">Manual Pin</option>
						  <option value="County GIS Parcel">County GIS Parcel</option>
						  <option value="Assessor Parcel Map">Assessor Parcel Map</option>
						  <option value="Survey">Survey</option>
						  <option value="Title Report">Title Report</option>
						  <option value="Deed Legal Description">Deed Legal Description</option>
						  <option value="KML / KMZ Upload">KML / KMZ Upload</option>
						  <option value="GeoJSON Upload">GeoJSON Upload</option>
						  <option value="Broker / Seller Provided">Broker / Seller Provided</option>
						  <option value="Auction Source">Auction Source</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Source
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Verification Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_11"  value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_11`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_11_Change} className="form-control" name="Boundary Verification Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Unverified">Unverified</option>
						  <option value="Auto-Geocoded">Auto-Geocoded</option>
						  <option value="Manually Drawn">Manually Drawn</option>
						  <option value="Needs Review">Needs Review</option>
						  <option value="Verified by Platform">Verified by Platform</option>
						  <option value="Verified by Survey">Verified by Survey</option>
						  <option value="Verified by Title / County Record">Verified by Title / County Record</option>
						  <option value="Disputed">Disputed</option>
						  <option value="Hidden / Confidential">Hidden / Confidential</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Verification Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Geometry Format`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_12"  value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_12`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_12_Change} className="form-control" name="Boundary Geometry Format"  >
						  <option value="Point">Point</option>
						  <option value="Bounding Box">Bounding Box</option>
						  <option value="Polygon GeoJSON">Polygon GeoJSON</option>
						  <option value="MultiPolygon GeoJSON">MultiPolygon GeoJSON</option>
						  <option value="FeatureCollection GeoJSON">FeatureCollection GeoJSON</option>
						  <option value="WKT">WKT</option>
						  <option value="KML / KMZ">KML / KMZ</option>
						  <option value="Encoded Polyline">Encoded Polyline</option>
						  <option value="Image Overlay Reference">Image Overlay Reference</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Geometry Format
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary GeoJSON`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_13" type="text" className="form-control" placeholder="Boundary GeoJSON" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_13`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_13_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_13"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary GeoJSON`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary WKT`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_14" type="text" className="form-control" placeholder="Boundary WKT" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_14`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_14_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_14"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary WKT`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '500ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Bounding Box`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_15" type="text" className="form-control" placeholder="Boundary Bounding Box" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_15`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_15_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_15"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '500ch' }}>
						 {t(`Enter Boundary Bounding Box`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Parcel ID List`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_16" type="text" className="form-control" placeholder="Parcel ID List" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_16`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_16_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_16"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Parcel ID List`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Legal Description Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_17" type="text" className="form-control" placeholder="Legal Description Link" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_17`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_17_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_17"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Legal Description Link`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Survey Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_18" type="text" className="form-control" placeholder="Survey Document Link" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_18`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_18_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_18"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Survey Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Boundary Last Verified Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_19" type="date"  value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_19`]} 
							onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_19_Change} style={{ borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_19"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Boundary Last Verified Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Verified By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_20" type="text" className="form-control" placeholder="Boundary Verified By" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_20`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_20_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_20"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Boundary Verified By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '1000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Disclaimer`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_21" type="text" className="form-control" placeholder="Map Disclaimer" value={PREAUCT_AUCTION_OPPORTUNITY["8"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_21`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_21_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_8_21"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '1000ch' }}>
						 {t(`Enter Map Disclaimer`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_0"  value={PREAUCT_AUCTION_OPPORTUNITY["9"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_0`]} onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_1" type="text" className="form-control" placeholder="Created By" value={PREAUCT_AUCTION_OPPORTUNITY["9"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_1`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_2" type="text" className="form-control" placeholder="Created At" value={PREAUCT_AUCTION_OPPORTUNITY["9"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_2`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_3" type="text" className="form-control" placeholder="Updated By" value={PREAUCT_AUCTION_OPPORTUNITY["9"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_3`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_4" type="text" className="form-control" placeholder="Updated At" value={PREAUCT_AUCTION_OPPORTUNITY["9"][`PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_4`]} 
						onChange={PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_01_SPONSOR_AUCTION_OPPORTUNITY_INTAKE_PREAUCT_AUCTION_OPPORTUNITY_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default PREAUCT_Auction_Opportunity;  